import {
  processStart,
  processError,
  addSuccess,
  removeSuccess,
  loadSuccess,
} from "./userSlice";
import {
  processEventStart,
  processEventError,
  addEventSuccess,
  removeEventSuccess,
  loadEventSuccess,
} from "./calendarSlice";
import { firestore } from "../firebase";
import {
  doc,
  setDoc,
  arrayUnion,
  arrayRemove,
  collection,
  addDoc,
  deleteDoc,
  getDoc,
  query,
  where,
  limit,
  orderBy
} from "@firebase/firestore";
import { getDocs } from "firebase/firestore";
import moment from "moment";

// Bookmark functions
export const addBookmark = async (univname, userUID, dispatch) => {
  dispatch(processStart());
  try {
    const bookmarkRef = doc(firestore, "User", userUID);
    await setDoc(
      bookmarkRef,
      { bookmarkList: arrayUnion(univname) },
      { merge: true }
    );
    dispatch(addSuccess(univname));
  } catch (err) {
    dispatch(processError());
  }
};

export const removeBookmark = async (univname, userUID, dispatch) => {
  dispatch(processStart());
  try {
    const bookmarkRef = doc(firestore, "User", userUID);
    await setDoc(
      bookmarkRef,
      { bookmarkList: arrayRemove(univname) },
      { merge: true }
    );
    dispatch(removeSuccess(univname));
  } catch (err) {
    dispatch(processError());
  }
};

export const loadBookmark = async (userUID, dispatch) => {
  dispatch(processStart());
  try {
    const bookmarkRef = doc(firestore, "User", userUID);
    const docSnap = await getDoc(bookmarkRef);
    if (docSnap.exists()) {
      // console.log("Document data:", docSnap.data());
      //console.log("Document data:", docSnap.data().bookmarkList);
      dispatch(loadSuccess(docSnap.data().bookmarkList));
    }
  } catch (err) {
    dispatch(processError());
  }
};

// Calendar functions
export const addCalendarEvent = async (calendarData, userUID, dispatch) => {
  dispatch(processEventStart());
  try {
    const calendarRef = collection(firestore, "User", userUID, "Calendar");
    const docRef = await addDoc(calendarRef, calendarData);
    calendarData.id = docRef.id;
    dispatch(addEventSuccess(calendarData));
  } catch (err) {
    dispatch(processEventError());
  }
};

export const removeCalendarEvent = async (calendarDataId, userUID, dispatch) => {
  dispatch(processEventStart());
  try {
    const calendarRef = doc(
      firestore,
      "User",
      userUID,
      "Calendar",
      calendarDataId
    );
    await deleteDoc(calendarRef);
    dispatch(removeEventSuccess(calendarDataId));
  } catch (err) {
    dispatch(processEventError());
  }
};

export const loadCalendarEvent = async (userUID, dispatch) => {
  dispatch(processEventStart());
  try {
    const events = [];
    const calendarRef = collection(firestore, "User", userUID, "Calendar");
    const qEnd = query(calendarRef, where("end", ">=", new Date()), orderBy("end"), limit(20));
    const querySnapshot1 = await getDocs(qEnd);
    querySnapshot1.forEach((doc) => {
      let event = {...doc.data()}
      event.start = moment.unix(doc.data().start.seconds).toDate();
      event.end = moment.unix(doc.data().end.seconds).toDate();
      event.id = doc.id;
      // console.log(moment.unix(doc.data().start.seconds).toDate());
      // console.log(event.start);
      events.push(event);
    });
    dispatch(loadEventSuccess(events));
  } catch (err) {
    dispatch(processEventError());
  }
};
